import { render, staticRenderFns } from "./DoctorLayout.vue?vue&type=template&id=25f3a26b&"
import script from "./DoctorLayout.vue?vue&type=script&lang=js&"
export * from "./DoctorLayout.vue?vue&type=script&lang=js&"
import style0 from "./DoctorLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports